import { render, staticRenderFns } from "./BankDeposit.vue?vue&type=template&id=1154eb88"
import script from "./BankDeposit.vue?vue&type=script&lang=ts"
export * from "./BankDeposit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports